var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_676_58991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 27.5C8.09625 27.5 2.5 21.9037 2.5 15C2.5 8.09625 8.09625 2.5 15 2.5C21.9037 2.5 27.5 8.09625 27.5 15C27.5 21.9037 21.9037 27.5 15 27.5ZM15 25C17.6522 25 20.1957 23.9464 22.0711 22.0711C23.9464 20.1957 25 17.6522 25 15C25 12.3478 23.9464 9.8043 22.0711 7.92893C20.1957 6.05357 17.6522 5 15 5C12.3478 5 9.8043 6.05357 7.92893 7.92893C6.05357 9.8043 5 12.3478 5 15C5 17.6522 6.05357 20.1957 7.92893 22.0711C9.8043 23.9464 12.3478 25 15 25ZM13.75 18.75H16.25V21.25H13.75V18.75ZM16.25 16.6937V17.5H13.75V15.625C13.75 15.2935 13.8817 14.9755 14.1161 14.7411C14.3505 14.5067 14.6685 14.375 15 14.375C15.3551 14.375 15.7029 14.2741 16.0029 14.0842C16.3029 13.8942 16.5428 13.623 16.6947 13.302C16.8466 12.981 16.9042 12.6235 16.8609 12.2711C16.8175 11.9186 16.6749 11.5857 16.4498 11.3111C16.2246 11.0365 15.9261 10.8315 15.589 10.72C15.2519 10.6084 14.89 10.5948 14.5455 10.6809C14.201 10.7669 13.888 10.949 13.643 11.206C13.3979 11.463 13.2308 11.7843 13.1613 12.1325L10.7088 11.6412C10.8608 10.8814 11.2119 10.1755 11.7262 9.59573C12.2404 9.016 12.8994 8.58323 13.6357 8.34165C14.3721 8.10007 15.1594 8.05836 15.9171 8.22077C16.6748 8.38318 17.3759 8.74389 17.9485 9.26603C18.5212 9.78817 18.9449 10.453 19.1764 11.1926C19.4079 11.9322 19.4388 12.7199 19.2661 13.4754C19.0933 14.2308 18.7231 14.9269 18.1932 15.4923C17.6632 16.0578 16.9927 16.4724 16.25 16.6937Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_676_58991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.57753409df3f48cc8d73a0e003450b24.svg";
export { ForwardRef as ReactComponent };